import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import AgreementField from '@sprinx/cvo-eshop-ui-common/components/AgreementField';
import AgreementFieldLink from '@sprinx/cvo-eshop-ui-common/components/AgreementFieldLink';
import clsx from 'clsx';
import { pickHTMLProps } from 'pick-react-known-prop';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles(
  (theme) => ({
    label: {
      fontWeight: 600,
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5),
    },
    link: {
      fontWeight: 600,
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
    },
  }),
  { name: 'AgreementFieldTerms' },
);

function AgreementFieldTerms({ classes: pClasses, className, error, onChange, value, ...rest }) {
  const classes = useStyles({ classes: pClasses });

  return (
    <div {...pickHTMLProps(rest)} className={clsx(classes.root, className)}>
      <AgreementField value={value} onChange={onChange} error={error} {...rest}>
        <Typography variant='body1' className={classes.label}>
          Sunt de acord cu
          <AgreementFieldLink {...rest} to='/info/termeni-si-conditii' className={classes.link}>
            termenii și condițiile
          </AgreementFieldLink>
          standard ale contractului. Sunt familiarizat cu procesul și domeniul de aplicare al colectării datelor cu
          caracter personal și, pe baza acestuia, îmi dau acordul pentru colectarea și prelucrarea acestora.
        </Typography>
      </AgreementField>
    </div>
  );
}

AgreementFieldTerms.propTypes = {
  classes: PropTypes.shape({
    label: PropTypes.string,
    link: PropTypes.string,
    root: PropTypes.string,
  }),
  className: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
};

AgreementFieldTerms.defaultProps = {
  classes: undefined,
  className: undefined,
  error: undefined,
  onChange: undefined,
};

export default AgreementFieldTerms;
